import { render, staticRenderFns } from "./Heirs.vue?vue&type=template&id=eb967084&"
import script from "./Heirs.vue?vue&type=script&lang=js&"
export * from "./Heirs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports